module.exports = __webpack_public_path__ + "assets/images/gelo_dd54278bc6414d772a5f97b5394a6d60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cubo/gelo.png
// module id = 199
// module chunks = 0